import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ErrorProvider } from "./context/Error";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const rootElement = document.getElementById("root");
const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!stripePublicKey) {
  throw new Error("Missing Stripe public key in environment variables.");
}

const stripePromise = loadStripe(stripePublicKey);

if (rootElement) {
  // Create a root
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <ErrorProvider>
      <Elements stripe={stripePromise}>
      <App />
      </Elements>
    </ErrorProvider>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals({});
